import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import { Title } from '../Utilities'
import { scrollToRef } from '../../helpers'

function PrimaryHeroV3({
  title,
  text,
  buttonTxt,
  children,
  scrollRef,
  legal,
  link,
  fullWidthHeader
}) {
  return (
    <div className={legal ? 'primary-hero primary-hero--legal' : 'primary-hero'}>
      <div className="container__inner">
        <div
          className={`primary-hero__content-box ${
            fullWidthHeader ? 'primary-hero__content-box--fw-header' : ''
          }`}
        >
          <Title className="primary-hero__heading">{title}</Title>

          {children}

          {text && <p className="primary-hero__text general-text">{text}</p>}
        </div>

        {buttonTxt && (
          <div className="primary-hero__button-box">
            {link ? (
              <Link className="button" to={link} data-event="home">
                {buttonTxt}
              </Link>
            ) : (
              <button
                className="button"
                onClick={() => scrollToRef(scrollRef, '', 'start')}
                type="button"
              >
                {buttonTxt}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

/* eslint-disable react/require-default-props */
PrimaryHeroV3.defaultProps = {
  legal: false
}

PrimaryHeroV3.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  scrollRef: PropTypes.object,
  buttonTxt: PropTypes.string,
  legal: PropTypes.bool,
  link: PropTypes.string,
  children: PropTypes.node,
  fullWidthHeader: PropTypes.bool
}

export default PrimaryHeroV3
